<template>
  <a-card title="用户管理"
          :bordered="false"
          style="width: 100%;height:100%;overflow:hidden">
    <template #extra>
      <a-checkbox v-model:checked="selectChoose">多选</a-checkbox>
      <a-button size="normal"
                @click="refreshData">刷新</a-button>
      <a-button v-p="'/authorizations/users:POST'"
                size="normal"
                @click="createRole">创建用户</a-button>
    </template>
    <div class="menu-table">
      <a-scroll-table :data-source="dataSource"
                      row-key="id"
                      :columns="columns"
                      :custom-row="customRowFn"
                      :loading="loading"
                      :row-selection="{ selectedRowKeys: selectedRow, onChange: onSelectChange, type: !selectChoose ? 'radio' : 'checkbox' }">
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'state'">
            <div class="editable-cell">
              <div class="editable-cell-text-wrapper">
                <a-tag :color="record.subExt.enable == true ? 'success' : 'error'">{{ record.subExt.enable == true ?
                  '活跃' : '已禁用'
                }}
                </a-tag>
              </div>
            </div>
          </template>
          <template v-if="column.dataIndex === 'manager'">
            <div class="editable-cell">
              <div class="editable-cell-text-wrapper">
                <a-tag :color="record.isAdmin == true ? 'success' : 'error'">{{ record.isAdmin == true ? '是' : '否' }}
                </a-tag>
              </div>
            </div>
          </template>
          <template v-else-if="column.dataIndex === 'operation'">
            <a v-p="'/authorizations/users/:id:POST'"
               @click="editRow(record)">编辑</a>
            <a-dropdown>
              <a style="margin-left:10px">更多</a>
              <DownOutlined />
              <template #overlay>
                <a-menu @click="menusClick">
                  <a-menu-item key="1"
                               v-p="'/authorizations/users/:id:PUT'"
                               :data="record">修改密码</a-menu-item>
                  <a-menu-item key="2"
                               v-p="'/authorizations/users/:id:DELETE'"
                               :data="record">删除</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </template>
      </a-scroll-table>
    </div>
    <a-modal v-model:visible="userVisible"
             :title="editState ? '编辑' : '新建'"
             :confirm-loading="confirmLoading"
             @ok="userFormConfirm">
      <a-form :model="userForm"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 24 }">
        <a-form-item label="用户名"
                     name="username"
                     :rules="[{ required: true, validator: formValidate.username }]">
          <a-input v-model:value="userForm.username" />
        </a-form-item>
        <a-form-item v-if="editState == false"
                     label="密码"
                     name="password"
                     :rules="[{ required: true, validator: formValidate.password }]">
          <a-input v-model:value="userForm.password"
                   type="password" />
        </a-form-item>
        <a-form-item label="邮箱"
                     name="email"
                     :rules="[{ required: true, validator: formValidate.email }]">
          <a-input v-model:value="userForm.email" />
        </a-form-item>
        <a-form-item label="状态"
                     name="enable"
                     :rules="[{ required: true }]">
          <a-switch v-model:checked="userForm.enable"
                    checked-children="激活"
                    un-checked-children="禁用" />
        </a-form-item>
        <a-form-item label="管理员"
                     name="isAdmin"
                     :rules="[{ required: true }]">
          <a-switch v-model:checked="userForm.isAdmin"
                    checked-children="激活"
                    un-checked-children="禁用" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model:visible="deleteRoleVisible"
             title="删除"
             :confirm-loading="confirmLoading"
             @ok="deleteRoleConfirm">
      <p style="font-size:16px">是否删除用户：<span style="color:red">{{ deleteUserForm.username }}</span></p>
    </a-modal>
    <a-modal v-model:visible="editPasswordVisible"
             title="修改密码"
             :confirm-loading="confirmLoading"
             @ok="editPasswordConfirm">
      <a-form :model="userForm"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 24 }">
        <a-form-item label="修改密码"
                     name="password"
                     :rules="[{ required: true, message: '请输入密码' }]">
          <a-input v-model:value="userForm.password"
                   type="password"
                   placeholder="请输入密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script setup lang="ts">
import { CORE_AXIOS, Http } from '@/core'
import type { RbacUserState } from '@/plugins'
import { message, type MenuProps } from 'ant-design-vue'
import { AScrollTable } from '@iota-cn/ui-components'
import { remove, assign } from 'lodash'
import { container } from 'tsyringe'
import { onMounted, reactive, ref } from 'vue'
import { Validator } from '@iota-cn/util-validation'
import { useRbacStore } from '../../DefaultRbacPagePlugin'
import type { Rule } from 'ant-design-vue/lib/form'
const Rbac = useRbacStore()
const selectedRow: Array<string> = reactive([])
const axios = container.resolve<Http>(CORE_AXIOS)
const userForm = reactive<UserFormState>({
  email: "",
  enable: true,
  isAdmin: false,
  password: '',
  subExt: { enable: true },
  username: ""
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const deleteUserForm = reactive<any>({})
const selectChoose = ref<boolean>(false)
const loading = ref<boolean>(false)
const userVisible = ref<boolean>(false)
const deleteRoleVisible = ref<boolean>(false)
const editState = ref<boolean>(false)
const editPasswordVisible = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)

onMounted(() => {
  refreshData()
})

// 表格有两种点击响应逻辑，点击多选框/单选框 和 点击一列
// 多选/单选 选中后的操作逻辑
const onSelectChange = (keys: Array<string>) => {
  remove(selectedRow)
  selectedRow.push(...keys)
}

// 表格 选择列 单选/多选 操作逻辑
const customRowFn = (record: RbacUserState) => {
  return {
    onclick: () => {
      // 判断为单选情况
      if (!selectChoose.value) {
        remove(selectedRow)
        selectedRow.push(record.id)
        Rbac.$patch((state) => {
          state.models.user = [record]
        })
      }
      // 判断为多选的情况
      else {
        if (!selectedRow.find(item => item == record.id)) {
          selectedRow.push(record.id)
        } else {
          selectedRow.forEach((item, index) => {
            if (item == record.id) {
              selectedRow.splice(index, 1)
            }
          })
        }
      }
    }
  }
}

const menusClick: MenuProps['onClick'] = (clickData) => {
  if (clickData.key == '1') menusClickFunc.edit(clickData.item.data)
  else if (clickData.key == '2') menusClickFunc.delete(clickData.item.data)
}

const menusClickFunc = {
  edit: (rowData: RbacUserState) => {
    Object.assign(userForm, rowData)
    editPasswordVisible.value = true
  },
  delete: (rowData: RbacUserState) => {
    Object.assign(deleteUserForm, rowData)
    deleteRoleVisible.value = true
  }
}


// 刷新 Func
const refreshData = () => {
  loading.value = true
  axios.get('/v1/api/authorizations/users').then(result => {
    const { users = [] } = result as { users: RbacUserState[], total: number }
    dataSource.length = 0
    dataSource.push(...users)
    loading.value = false
  }).catch(() => {
    loading.value = false
    message.error('获取用户列表失败')
  })
}

// 创建用户 Func
const createRole = () => {
  Object.assign(userForm, {
    email: "",
    enable: true,
    isAdmin: false,
    password: null,
    subExt: { enable: true },
    username: ""
  })
  userVisible.value = true
  editState.value = false
}

// 创建用户 确认 Func
const userFormConfirm = () => {
  userForm.subExt.enable = !!userForm.enable
  confirmLoading.value = true
  if (!editState.value) {
    axios.post('/v1/api/authorizations/users', userForm).then(() => {
      userVisible.value = false
      confirmLoading.value = false
      message.success('创建成功')
      refreshData()
    }).catch(() => {
      message.error('创建失败')
      confirmLoading.value = false
    })
  } else {
    const { id, username, email, subExt, enable, isAdmin } = userForm
    subExt.enable = !!enable
    axios.put('/v1/api/authorizations/users/' + id, { username, email, subExt, isAdmin }).then(() => {
      userVisible.value = false
      confirmLoading.value = false
      message.success('编辑成功')
      refreshData()
    }).catch(() => {
      message.error('编辑失败')
      confirmLoading.value = false
    })
  }
}

// 删除角色 确认 Func
const deleteRoleConfirm = () => {
  const { id } = (deleteUserForm as RbacUserState)
  confirmLoading.value = true
  axios.delete("/v1/api/authorizations/users/" + id).then(() => {
    deleteRoleVisible.value = false
    confirmLoading.value = false
    message.success('删除成功')
    refreshData()
  }).catch(() => {
    confirmLoading.value = false
    message.error('删除失败')
  })
}

// 修改密码 确认 Func
const editPasswordConfirm = () => {
  const { id, password } = userForm
  axios.put("/v1/api/authorizations/users/" + id, { password }).then(() => {
    loading.value = false
    editPasswordVisible.value = false
    message.success('修改成功')
    refreshData()
  }).catch(() => {
    editPasswordVisible.value = false
    message.error('修改失败')
  })
}

// 表单校验规则
const formValidate = {
  /** 用户是否重复 */
  username: (_rule: Rule, value: string): Promise<string | void> => {
    if (value.length <= 1) {
      return Promise.reject('用户名不允许为空或长度小于1')
    } else {
      return axios.get(`/v1/api/validations/usernames/validate?username=${value}`).then(() => {
        return Promise.resolve()
      }).catch(() => {
        return Promise.reject('用户名已重复')
      })
    }
  },
  /** 密码长度 */
  password: (_rule: Rule, value: string): Promise<string | void> => {
    if (Validator.isPassword(value)) {
      return Promise.resolve()
    } else {
      return Promise.reject('长度必须在6位到16位之间')
    }
  },
  /** 邮箱 */
  email: (_rule: Rule, value: string): Promise<string | void> => {
    return axios.get(`/v1/api/validations/emails/validate?email=${value}`).then(() => {
      return Promise.resolve()
    }).catch(() => {
      return Promise.reject('邮箱格式不正确或邮箱地址已存在')
    })
  }
}

// 编辑数据
const editRow = (rowData: RbacUserState) => {
  assign(userForm, rowData)
  userVisible.value = true
  editState.value = true
}

const dataSource = reactive<RbacUserState[]>([])
const columns = ref([
  {
    title: '登录名',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: '状态',
    dataIndex: 'state',
    key: 'state',
  },
  {
    title: '管理员',
    dataIndex: 'manager',
    key: 'manager',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    width: 100
  }
])

interface UserFormState {
  id?: string
  email: string
  enable: boolean
  isAdmin: boolean
  password: string
  subExt: { enable: boolean }
  username: string
}

</script>

<style lang="less" scoped>
.menu-table {
  display: flex;
  flex: 1;
  height: 80%
}

:deep(.ant-card-body) {
  height: 100%;
  overflow-y: auto
}

:deep(.ant-table) {
  table {
    table-layout: fixed !important;
  }
}

:deep(.ant-table-tbody) {
  tr>td {
    word-wrap: break-word;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
